import { useMemo } from 'react';
import applicationConstants from '../../../../Core/Utility/ApplicationConstants';
import { DemeterMarket, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import Dropdown from './Dropdown';

type UnitOfMeasureDropdownOptionsType = { label: string; value: UnitOfMeasure | undefined };

interface IUnitOfMeasureGeneralDropdownProps {
    disabled?: boolean;
    unitOfMeasure?: UnitOfMeasure;
    handleChange: (value: UnitOfMeasure | undefined) => void;
    market?: DemeterMarket;
    label?: string;
    overrideUnits?: UnitOfMeasure[];
    hideNativeOption?: boolean;
    track: TrackingEvent;
}

const UnitOfMeasureGeneralDropdown: React.FC<IUnitOfMeasureGeneralDropdownProps> = (props: IUnitOfMeasureGeneralDropdownProps): JSX.Element => {
    const [translations] = useLanguage();

    const unitOfMeasureDropdownOptions = useMemo(() => {
        const options = [] as UnitOfMeasureDropdownOptionsType[];
        let unitOfMeasureByMarket: UnitOfMeasure[] = [...applicationConstants.AvailableGeneralUnitOfMeasures];
        if (props.market === DemeterMarket.Energy) {
            unitOfMeasureByMarket = [...applicationConstants.AvailableEnergyUnitOfMeasures];
        }

        if (!props.hideNativeOption) {
            options.push({
                label: translations.dropdown.nativeUnits,
                value: undefined,
            } as UnitOfMeasureDropdownOptionsType);
        }

        (!props.overrideUnits ? unitOfMeasureByMarket : [...(props.overrideUnits ?? [])]).forEach((x) => {
            options.push({
                label: translations.unitOfMeasure[x],
                value: x,
            });
        });

        return options;
    }, [translations, props.overrideUnits, props.hideNativeOption, props.market]) as UnitOfMeasureDropdownOptionsType[];

    return (
        <Dropdown
            disabled={props.disabled}
            value={props.unitOfMeasure ?? undefined}
            options={unitOfMeasureDropdownOptions}
            handleOptionChange={(value: UnitOfMeasure | undefined) => props.handleChange(value)}
            label={props.label}
            track={props.track}
        />
    );
};

export default UnitOfMeasureGeneralDropdown;
